package fr.xibalba.generateurClassesLycee.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page

@Page
@Composable
fun ElevesPage() {
}